import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-19ed43ff")

_pushScopeId("data-v-19ed43ff")
const _hoisted_1 = { class: "stat-categories" }
const _hoisted_2 = {
  key: 0,
  class: "stat-categories__body"
}
const _hoisted_3 = { class: "row align-items-stretch stat-categories__list" }
const _hoisted_4 = { class: "row" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TabHead = _resolveComponent("TabHead")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_TabHead, {
      active: $setup.activeTab,
      items: $setup.tabs,
      class: "stat-categories__tab-head",
      onSelect: $setup.changePage
    }, null, 8, ["active", "items", "onSelect"]),
    ($props.body)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.getBulletins, (bulletin) => {
              return (_openBlock(), _createBlock("div", {
                key: bulletin.id,
                class: "col-12 mb-4 col-md-6 col-lg-4 col-xl-3"
              }, [
                _createVNode(_component_router_link, {
                  to: {
            name: 'statisticsResult',
            params: {
              newBulletinId: bulletin.id,
              categoryId: $setup.category,
              newBulletinName: $setup.getStatTreeName(bulletin) || bulletin.name
            }
          },
                  class: "stat-categories__item"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_svg_icon, {
                      name: $setup.getNextImg()
                    }, null, 8, ["name"]),
                    _createVNode("span", null, _toDisplayString($setup.getStatTreeName(bulletin) || bulletin.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", null, [
              ($setup.bulletinLMore && !$setup.bulletinLActive)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "btn default-btn stat-categories__more",
                    onClick: _cache[1] || (_cache[1] = $event => ($setup.bulletinLActive = true))
                  }, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('labels.yetStat')), 1),
                    _createVNode(_component_svg_icon, { name: "arrowright-white" })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})